module.exports = __webpack_public_path__ + "static/media/place_viejo.f00335ec.svg";